module.exports = __webpack_public_path__ + "img/TradingView-img1-mobile.4ffa95ae.png";